export const groupPermissionsByCategory = (permissions = []) => {
    return (permissions || []).reduce((acc, p) => {
        const key = p.category || "Uncategorized";
        acc[key] = acc[key] || [];
        acc[key].push(p);
        return acc;
    }, {});
};

